import React from 'react'

import { Button, Flex, Text, Tooltip } from 'components/ds'

import SubscriptionRow from './subscription-row'
import type { CardDetails } from './utils'
import { ADMIN_ONLY_MESSAGE } from './utils'

type Props = {
  card: CardDetails | null
  billedTo: string[]
  isAdmin: boolean
  /** Without it, Manage billing is disabled */
  onManageBilling?: () => void
}

/** Card on file and billing contact, with the CTA to manage them in Chargebee. */
const BillingDetailsRow = ({
  card,
  billedTo,
  isAdmin,
  onManageBilling,
}: Props): React.ReactNode => {
  const manageBillingLabel = 'Manage billing'

  let cardLabel: string
  if (!card) {
    cardLabel = 'No card on file'
  } else if (card.last4) {
    cardLabel = `${card.brand ?? 'Card'} ending in ${card.last4}`
  } else {
    cardLabel = 'Credit card'
  }

  return (
    <SubscriptionRow
      title="Billing details"
      subtitle={cardLabel}
      aside={
        isAdmin ? (
          <Button
            variant="soft"
            color="gray"
            size="2"
            disabled={!onManageBilling}
            onClick={onManageBilling}
          >
            {manageBillingLabel}
          </Button>
        ) : (
          <Tooltip content={ADMIN_ONLY_MESSAGE}>
            {/* aria-disabled instead of disabled: a natively disabled button swallows the pointer events its tooltip needs */}
            <Button
              variant="soft"
              color="gray"
              size="2"
              aria-disabled
              data-disabled
            >
              {manageBillingLabel}
            </Button>
          </Tooltip>
        )
      }
    >
      {billedTo.length > 0 && (
        <Flex direction="column">
          <Text size="1" weight="medium" mb="1">
            Billed to:
          </Text>
          {billedTo.map((line, index) => (
            <Text key={index} size="1">
              {line}
            </Text>
          ))}
        </Flex>
      )}
    </SubscriptionRow>
  )
}

export default BillingDetailsRow
